import { render, staticRenderFns } from "./ConsequencesInfo.vue?vue&type=template&id=30629d4b&"
import script from "./ConsequencesInfo.vue?vue&type=script&lang=js&"
export * from "./ConsequencesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30629d4b')) {
      api.createRecord('30629d4b', component.options)
    } else {
      api.reload('30629d4b', component.options)
    }
    module.hot.accept("./ConsequencesInfo.vue?vue&type=template&id=30629d4b&", function () {
      api.rerender('30629d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/ConsequencesInfo.vue"
export default component.exports